module.exports = __webpack_public_path__ + "static/media/sharechat-5.8edffc96.webp";